import { useContainerWidth } from '@fs/zion-ui'

export default function useIsMdWidth(breakpoint = 'lg') {
  const atWidth = useContainerWidth()
  return atWidth({
    [breakpoint]: false,
    default: true,
  })
}
